
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#FF9811","d":"M0 85.337h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M0 312.888h512v113.775H0z"}}),_c('circle',{attrs:{"fill":"#FF9811","cx":"256","cy":"256","r":"32"}})])
          )
        }
      }
    